 export const hardSkills = [
  {
    id: 0,
    name:'HTML',
    description: 'My knowledge about HTML includes all the structuring, with acessibility and semantic code, witch gives the user a better experience and functionality.'
  },
  {
    id: 1,
    name:'CSS',
    description: 'My knowledge about CSS includes variables for clean code, display flex, responsiveness for better user experience in multiple devices, and multiple functionalities for better UI.'
  },
  {
    id: 2,
    name:'JAVA-SCRIPT',
    description: `My knowledge about Java-Script goes from all the native features and interaction with the DOM, web storage,
    use of API's, objects and arrays manipulation, until the "newer" ES6, with high order fuctions and it's features, with arrows, template literals etc.`
  },
  {
    id: 3,
    name:'JEST',
    description: 'My knowledge about Jest cover all the essentials to cover an entire application with unitary tests.'
  },
  {
    id: 4,
    name:'REACT',
    description: 'My knowledge about React goes from all the older features, working with classes, state and life cycle, React router, to work with single page application etc. and the "newer" features with functional components, using Contex API and Hooks, to give life cycle to the components and work data between different pages and components.'
  },
  {
    id: 5,
    name:'REDUX',
    description: 'My knowledge about Redux is basic, but goes from work it with vannila JS, creating a global state, actions, dispatching etc. and React-Redux, using it with React to manage data from component to component.'
  },
]

export const hardSkillsPortuguese = [
  {
    id: 0,
    name:'HTML',
    description: 'Meu conhecimento sobre HTML inclui toda a estruturação, com acessibilidade e código semântico, o que proporciona ao usuário uma melhor experiência e funcionalidade.'
  },
  {
    id: 1,
    name:'CSS',
    description: 'Meu conhecimento sobre CSS inclui variáveis ​​para código limpo, display flex, recursos de responsabilidade, para uma melhor experiência do usuário em diversos dispositivos e funcionalidades para uma melhor IU.'
  },
  {
    id: 2,
    name:'JAVA-SCRIPT',
    description: `Meu conhecimento sobre Java-Script vai desde todos os recursos nativos e interação com o DOM, Local storage, utilização de API's, manipulação de objetos, arrays etc. até o "mais novo" ES6, com funções de alto nível e seus recursos, com arrows, template literals etc.`
  },
  {
    id: 3,
    name:'JEST',
    description: 'Meu conhecimento sobre Jest envolve todos os fundamentos para cobrir uma aplicação inteira com testes unitários.'
  },
  {
    id: 4,
    name:'REACT',
    description: 'Meu conhecimento sobre React vai de todos os recursos "mais antigos", trabalhando com classes, estados e ciclo de vida, React Router, para aplicação single page etc. e os recursos "mais novos" com componentes funcionais, usando API Contex e hooks, para dar um ciclo de vida para os componentes e, trabalhar com dados entre diferentes páginas e componentes.'
  },
  {
    id: 5,
    name:'REDUX',
    description: 'Meu conhecimento sobre Redux é básico, mas vai desde trabalhá-lo com JS vanilla, criando um estado global, actions, despatch etc. até o React-Redux, usando-o com React para gerenciar dados de componente a componente.'
  },
]

